import { getApiBase } from './config';
import { getDeviceId } from '../widget-lib/device-id-bridge';

/** POST /api/v1/media/upload — Bearer из сессии виджета. */
export async function uploadMediaWithToken(
  file: File,
  accessToken: string,
  options?: { imageProfile?: 'square' | 'organization_wide' | 'square_small'; signal?: AbortSignal }
): Promise<{ url?: string; key?: string }> {
  const signal = options?.signal;
  const imageProfile = options?.imageProfile;
  const formData = new FormData();
  formData.append('file', file);
  const qs = imageProfile ? `?image_profile=${encodeURIComponent(imageProfile)}` : '';
  const base = getApiBase();
  const headers: Record<string, string> = { Authorization: `Bearer ${accessToken}` };
  const did = getDeviceId();
  if (did) headers['X-Device-Id'] = did;
  const response = await fetch(`${base}/api/v1/media/upload${qs}`, {
    method: 'POST',
    headers,
    body: formData,
    signal
  });
  const ct = response.headers.get('content-type') ?? '';
  const raw = await response.text();
  if (!response.ok) {
    if (ct.includes('application/json') && raw.trim()) {
      try {
        const payload = JSON.parse(raw) as { detail?: unknown };
        const d = payload.detail;
        const msg =
          typeof d === 'string'
            ? d
            : Array.isArray(d) && d[0] && typeof d[0] === 'object' && d[0] !== null && 'msg' in d[0]
              ? String((d[0] as { msg?: string }).msg)
              : `HTTP ${response.status}`;
        throw new Error(msg);
      } catch {
        throw new Error(raw || `HTTP ${response.status}`);
      }
    }
    throw new Error(raw || `HTTP ${response.status}`);
  }
  if (!ct.includes('application/json') || !raw.trim()) {
    return {};
  }
  return JSON.parse(raw) as { url?: string; key?: string };
}
